export function OutlineScreenIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.08 6H4.92C3.85961 6 3 6.85961 3 7.92V16.08C3 17.1404 3.85961 18 4.92 18H19.08C20.1404 18 21 17.1404 21 16.08V7.92C21 6.85961 20.1404 6 19.08 6Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2512 12.9988L12.7488 12.0004L11.2512 11.002V12.9988Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
